<ng-content>

</ng-content>
@if (isLoading) {
  <mat-progress-bar mode="indeterminate" [style]="{ height: '6px' }"></mat-progress-bar>
} @else if (!threads.length) {
  <button class="thread w-full">
    <span class="title grid">
      <span class='col text-left'>
          No messages found
      </span>
    </span>
  </button>
} @else {
  <ul>
    @for (thread of threads; track thread.id) {
      <li class="thread border-bottom-1 border-color-50"
          [class.active-thread]="thread.id === selectedThread?.id">
        <button (click)="selectThread(thread)" class="thread w-full"
                [class.bold]="thread.unReadCount > 0">
        <span>
          <span class="title grid">
            <span class="col text-left">{{ thread.parentCategoryName }}</span>
            <span class="message_date col text-right" [matTooltip]="getFormattedTimeTooltip(thread)">
                @if (thread.messages.length) {
                  {{ thread.messages.length ? getFormattedTime(thread) : null }}
                }
            </span>
          </span>
          <span class="thread-description grid">
            <span class="col text-left">
              @if (thread.messages.length) {
                {{ getMessageText(thread) }}
              } @else {
                Click to begin conversation
              }
            </span>
          </span>
        </span>
        </button>
      </li>
    }
  </ul>
}
